import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import PageNotFound from './components/PageNotFound.vue'

Vue.use(Router)
var user = false;
var doctor = false;
function requireAuth (to, from, next) {
  if (localStorage.getItem('userLoggedIn') != undefined || localStorage.getItem('doctorLoggedIn') !=undefined) {
    if ( localStorage.getItem('userLoggedIn') || localStorage.getItem('doctorLoggedIn') ) {
        switch( to.meta.permission ){
          case 'user':
          if (localStorage.getItem('userLoggedIn')) {
            next();
          }else{
            next('/page-not-found');
          }
          break;
          case 'doctor':
            if( localStorage.getItem('doctorLoggedIn')){
              next();
            }else{
              next('/page-not-found');
            }
          break;
        }
    }
  }else{
    next('/:lang(bg|en|us)/');
  }
}
var lang = window.lang;
// alert(111)
const router =  new Router({
  // base: 'bg',
  mode: 'history',
  routes: [
    {
      path: '/:lang(bg|en|us)/',//'/:lang(bg|en|us)/',
      name: 'home',
      component: Home
    },
    {
      path: '/:lang(bg|en|us)/registration',
      name: 'registration',
      component:  require('./views/Registration.vue').default
    },
    {
      path: '/:lang(bg|en|us)/login',
      name: 'login',
      component:  require('./views/Login.vue').default
    },
    {
      path: '/logout',
      name: 'logout',
      component:  require('./views/users/Logout.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/:lang(bg|en|us)/blog',
      name: 'blog',
      component:  require('./views/FbBlog.vue').default
    },
    {
      path: '/:lang(bg|en|us)/privacy-policy',
      name: 'privacy-policy',
      component:  require('./views/PrivacyPolicy.vue').default
    },
    {
      path: '/:lang(bg|en|us)/general-terms',
      name: 'general-terms',
      component:  require('./views/GeneralTerms.vue').default
    },
    {
      path: '/:lang(bg|en|us)/registered-vets',
      name: 'registered-vets',
      component:  require('./views/RegisteredVets.vue').default
    },
    {
      path: '/doctor-logout',
      name: 'doctor-logout',
      component:  require('./views/doctors/DoctorLogout.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'doctor'
        }
    },
    {
      path: '/:lang(bg|en|us)/user-home-page',
      name: 'user-home-page',
      component:  require('./views/users/UserHomePage.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/update-user-profile',
      name: 'update-user-profile',
      component:  require('./views/users/UpdateUserProfile.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/preview-user-profile',
      name: 'preview-user-profile',
      component:  require('./views/users/UserProfile.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/user-notificarions',
      name: 'user-notificarions',
      component:  require('./views/notification/Notifications.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/pets-home',
      name: 'pets-home',
      component:  require('./views/pets/PetsHome.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/pets-registration',
      name: 'pets-registration',
      component:  require('./views/pets/PetsRegistration.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/view-pet-profile/:petId',
      name: 'view-pet-profile',
      component:  require('./views/pets/ViewPetProfile.vue').default,
      beforeEnter: (to ,from, next) => {
        next();
      },
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/payment-notification/:status',
      name: 'payment-notification',
      component:  require('./views/PaymentNotification.vue').default,
      beforeEnter: (to ,from, next) => {
        next();
      },
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/update-pet-profile/:petId',
      name: 'update-pet-profile',
      component:  require('./views/pets/UpdatePetProfile.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/view-pet-reviews/:petId',
      name: 'view-pet-reviews',
      component:  require('./views/pets/PetsReviews.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/searching-vet',
      name: 'searching-vet',
      component:  require('./views/users/SerachVet.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/favorite-vet',
      name: 'favorite-vet',
      component:  require('./views/users/FavoriteUserVets.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/get-payment-status',
      name: 'get-payment-status',
      component:  require('./views/payment/getPaymentStatus.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'user'
        }
    },
    {
      path: '/preview-doctor-profile',
      name: 'preview-doctor-profile',
      component:  require('./views/doctors/DoctorProfile.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'doctor'
        }
    },
    {
      path: '/search-pet',
      name: 'search-pet',
      component:  require('./views/doctors/SearchPet.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'doctor'
        }
    },
    {
      path: '/doctor-add-review/:passportId/:petId',
      name: 'doctor-add-review',
      component:  require('./views/doctors/DoctorAddReviewPatien.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'doctor'
        }
    },
    {
      path: '/update-doctor-profile',
      name: 'update-doctor-profile',
      component:  require('./views/doctors/UpdateDoctorProfile.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'doctor'
        }
    },
    {
      path: '/:lang(bg|en|us)/doctor-home',
      name: 'doctor-home',
      component:  require('./components/DoctorHome.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'doctor'
        }
    },
    {
      path: '/add-patient',
      name: 'add-patient',
      component:  require('./components/AddPatient.vue').default,
      beforeEnter: requireAuth,
        meta: {
          permission: 'doctor'
        }
    },
    {
      path: '/:lang(bg|en|us)/support',
      name: 'support',
      component:  require('./views/admin/Support.vue').default
    },
    {
      path: '/:lang(bg|en|us)/about-us',
      name: 'about-us',
      component:  require('./views/AboutUs.vue').default
    },
    {
      path: '/:lang(bg|en|us)/faq',
      name: 'faq',
      component:  require('./views/Faq.vue').default
    },
    {
      path: '/reset-password/:role',
      name: 'reset-password',
      component:  require('./views/reset/ResetPassword.vue').default
    },
    {
      path: '/resetcode/:code/:email/:role',
      name: 'resetcode',
      component:  require('./views/reset/ResetCode.vue').default
    },
    {
      path: "*",
      name: 'home',
      component: Home
    }
  ]
})

export default router;
